/* Penoblo zentraler Quick-Add (ersetzt die früher 3x duplizierte Logik in
   Bestseller / Featured-Tabs / Collection). Ein delegierter Listener auf document
   behandelt alle Produktkarten-Buttons [data-add] sowie das Merken-Herz [data-fav].
   Einmal gebunden -> keine Listener-Leaks bei Section-Re-Render. Feuert 'cart:refresh'
   (Cart-Drawer-Listener im cart-drawer-Snippet aktualisiert den Drawer). */
(function () {
  if (window.__pnbQuickAddBound) return;
  window.__pnbQuickAddBound = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refreshBubble() {
    return fetch(root() + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Section-Rendering wrappt in .shopify-section — die Antwort enthaelt KEIN
        // Element mit id=cart-icon-bubble (die id sitzt nur im Header-Markup).
        var src = doc.querySelector('.shopify-section') || doc.body;
        var b = document.getElementById('cart-icon-bubble');
        if (b && src) b.innerHTML = src.innerHTML;
        // Mobile App-Leiste: eigenes Badge synchron halten (war reines Liquid ->
        // aktualisierte sich nie ohne Reload, QA #7).
        var countEl = src ? src.querySelector('.cart-count-bubble span[aria-hidden]') : null;
        var count = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
        var cartItem = document.querySelector('[data-pnb-appbar-cart]');
        if (cartItem) {
          var badge = cartItem.querySelector('.pnb-mobile-appbar__badge');
          if (count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'pnb-mobile-appbar__badge';
              cartItem.appendChild(badge);
            }
            badge.textContent = count;
            var tpl = cartItem.getAttribute('data-count-label');
            badge.setAttribute('aria-label', tpl ? tpl.replace('987654321', count) : count + ' Artikel im Warenkorb');
          } else if (badge) {
            badge.remove();
          }
        }
      })
      .catch(function () {});
  }

  function quickAdd(btn) {
    var id = btn.dataset.add;
    if (!id || btn.disabled) return;
    btn.disabled = true;
    btn.classList.remove('is-error');
    btn.classList.add('is-loading');
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) { throw d; } return d; }); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added'); announce((window.pnbStrings && window.pnbStrings.addedToCart) || 'In den Warenkorb gelegt');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        return refreshBubble();
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setTimeout(function () { btn.classList.remove('is-error'); }, 1600);
      })
      .finally(function () {
        setTimeout(function () { btn.disabled = false; btn.classList.remove('is-loading'); }, 600);
      });
  }

  /* UAT-Fix: Merken-Herzen überleben jetzt den Seitenwechsel (localStorage)
     und tragen von Anfang an aria-pressed. */
  var FAV_KEY = 'pnb-favs';
  function favIds() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (err) { return []; }
  }
  function initFavs() {
    var ids = favIds();
    document.querySelectorAll('[data-fav]').forEach(function (b) {
      var on = b.dataset.fav && ids.indexOf(b.dataset.fav) !== -1;
      b.classList.toggle('on', !!on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFavs);
  else initFavs();

  /* UAT-Fix (A11y): Quick-Add-Erfolg nicht nur als Farbwechsel, sondern als
     Screenreader-Ansage über eine Live-Region. */
  var live = document.createElement('div');
  live.setAttribute('aria-live', 'polite');
  live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)';
  (document.body || document.documentElement).appendChild(live);
  function announce(msg) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); }

  document.addEventListener('click', function (e) {
    var fav = e.target.closest('[data-fav]');
    if (fav) {
      e.preventDefault();
      var on = fav.classList.toggle('on');
      fav.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (fav.dataset.fav) {
        var ids = favIds().filter(function (x) { return x !== fav.dataset.fav; });
        if (on) ids.push(fav.dataset.fav);
        try { localStorage.setItem(FAV_KEY, JSON.stringify(ids)); } catch (err) { /* Privat-Modus */ }
      }
      announce(on
        ? (window.pnbStrings && window.pnbStrings.wishlistAdded) || 'Zur Merkliste hinzugefügt'
        : (window.pnbStrings && window.pnbStrings.wishlistRemoved) || 'Von der Merkliste entfernt');
      return;
    }
    var btn = e.target.closest('[data-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    quickAdd(btn);
  });
})();
